import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=ab806f28&scoped=true&"
var script = {}
import style0 from "./MainLayout.vue?vue&type=style&index=0&id=ab806f28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab806f28",
  null
  
)

export default component.exports